import React, { useState } from 'react';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import style from './style.module.less';
import IconNoDesc from '@/assets/icon-no-desc.png';
import Icon from '@/assets/icon.png';

/**
 * AI.GEN lines=1-80
 * 侧边栏组件 - 添加三个一级菜单：调度工作台、骑手分布图、盯盘工作台
 */
export const SideBar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const onChangeCollapsed = (newCollapsed: boolean) => {
    setCollapsed(newCollapsed);
  };

  // 菜单配置 - 使用 useMemo 确保语言切换时重新计算
  const menuItems = React.useMemo(
    () => [
      {
        key: '/admin/dispatch-workbench',
        label: t('menu.dispatchWorkbench'),
        path: '/admin/dispatch-workbench',
      },
      {
        key: '/admin/rider-distribution-map',
        label: t('menu.riderDistributionMap'),
        path: '/admin/rider-distribution-map',
      },
      {
        key: '/admin/monitoring-workbench',
        label: t('menu.monitoringWorkbench'),
        path: '/admin/monitoring-workbench',
      },
    ],
    [t, i18n.language],
  );

  const selectedKeys = [location.pathname];

  const onMenuClick = (e: any) => {
    const item = menuItems.find((menu) => menu.key === e.key);
    if (item) {
      navigate(item.path);
    }
  };

  return (
    <div className={`${style.sideBar} ${collapsed ? style.collapsed : ''}`}>
      {!collapsed ? (
        <div className={style.icon}>
          <img src={Icon} alt="Logo" />
        </div>
      ) : (
        <div className={style.iconNoDesc}>
          <img src={IconNoDesc} alt="Logo" />
        </div>
      )}

      <div className={style.menuBody}>
        <Menu
          onClick={onMenuClick}
          className={classNames(style.menu)}
          mode="inline"
          items={menuItems}
          theme="dark"
          selectedKeys={selectedKeys}
          inlineCollapsed={collapsed}
        />
      </div>

      <div
        className={classNames(style.toggleButton, {
          [style.collapsed]: collapsed,
        })}
        onClick={() => onChangeCollapsed(!collapsed)}
      >
        {collapsed ? <RightCircleOutlined /> : <LeftCircleOutlined />}
      </div>
    </div>
  );
};
